import { render, staticRenderFns } from "./panartisDetailList.vue?vue&type=template&id=74efa0d2&"
import script from "./panartisDetailList.vue?vue&type=script&lang=js&"
export * from "./panartisDetailList.vue?vue&type=script&lang=js&"
import style0 from "./panartisDetailList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports